var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { StepType } from "@types";
import { findSourceById, getSelectedStepDetailsById, handleStepFieldValueChanges, registerStep, validateFieldConfiguration, validateSource, validateStep, validateStepNameAndId } from "@utils";
import { FormSection } from "@components/FormSection/FormSection";
import { SourceSelectorInput } from "../SourceSelector/SourceSelectorInput";
import { SortEditor, validateSortConditions } from "../Sort/SortEditor";
import Icon from '@images/sort.svg';
export function renderStep(context, query, onChange, selectedStepId) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId);
    const _step = Object.assign({}, step);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        const { isValid, errors } = validateStep(query, step);
        setErrors(errors);
    }, [step]);
    const source = findSourceById(query, _step === null || _step === void 0 ? void 0 : _step.source);
    function onValueChange(field, value, source) {
        return __awaiter(this, void 0, void 0, function* () {
            const _query = yield handleStepFieldValueChanges(context, query, selectedStepId, field, value, source);
            onChange(_query);
        });
    }
    return React.createElement(React.Fragment, null,
        React.createElement(FormSection, { label: 'Source', error: errors === null || errors === void 0 ? void 0 : errors.source },
            React.createElement(SourceSelectorInput, { source: source, onChange: newSource => {
                    onValueChange('source', newSource, true);
                }, availableSources: [...previousSteps, ...selectedSources], query: query })),
        React.createElement(FormSection, { label: 'Sort by', error: errors === null || errors === void 0 ? void 0 : errors.attributes },
            React.createElement(SortEditor, { conditions: (_step === null || _step === void 0 ? void 0 : _step.attributes) || [], onChange: updated => onValueChange('attributes', updated), fields: (source === null || source === void 0 ? void 0 : source.schema) || [] })));
}
function validate(query, step) {
    const errors = validateStepNameAndId(step);
    // validate source
    const source = validateSource(query, step, 'source');
    if (!source.isValid)
        errors.source = source.error;
    const conditions = validateSortConditions(step === null || step === void 0 ? void 0 : step.attributes);
    if (conditions.isValid) {
        const fields = validateFieldConfiguration(query, step, conditions.uniqueAttributes, 'source');
        if (!fields.isValid)
            errors.attributes = fields.error;
    }
    else
        errors.attributes = conditions.error;
    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
}
registerStep({
    type: StepType.Sort,
    name: "Sort",
    description: "Sort data by one or more fields",
    icon: Icon,
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return Object.assign(Object.assign({}, basicProps), { source: previousSource, attributes: [] });
    }
});
